import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { AppRoutingModule } from "./app.routing";
import { MatSnackBarModule } from "@angular/material/snack-bar";

import { AppComponent } from "./app.component";
import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { AuthLayoutComponent } from "./layouts/auth-layout/auth-layout.component";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MatNativeDateModule } from "@angular/material/core";

import { ComponentsModule } from "./components/components.module";
import { HighchartsChartModule } from "highcharts-angular";
import { CarouselModule } from "ngx-owl-carousel-o";
import { DashboardLineGraphComponent } from "./dashboard-line-graph/dashboard-line-graph.component";
import { MatDialogModule } from "@angular/material/dialog";
import { ToastrModule } from "ngx-toastr";
import { ErrorInterceptor } from "./shared/error-interceptor";
import { CurrencyPipe } from "@angular/common";
import { AuthInterceptor } from "./auth/auth-interceptor";
import { AngularFireModule } from "@angular/fire";
import { AngularFireDatabaseModule } from "@angular/fire/database";
import { environment } from "src/environments/environment";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { XClientInterceptorInterceptor } from "./x-client-interceptor.interceptor";
import { UnguardedBreezeReportComponent } from './layouts/unguarded-breeze-report/unguarded-breeze-report.component';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ComponentsModule,
    NgbModule,
    RouterModule,
    AppRoutingModule,
    HighchartsChartModule,
    CarouselModule,
    MatDialogModule,
    MatSnackBarModule,
    ToastrModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireDatabaseModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    DashboardLineGraphComponent,
    UnguardedBreezeReportComponent,
  ],
  entryComponents: [],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: XClientInterceptorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    CurrencyPipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
